import { Amount, Consent, Transaction } from '~/types';
import axios from './axios';

export interface SendMoneyConsentData {
  sender: {
    accountId: string;
  };
  recipient: {
    accountId: string;
  };
  amount: Amount;
  localUTCOffset?: string;
  note?: string;
}

export interface SendMoneyBeneficiary {
  beneficiary: {
    profileType: string;
    name: string;
  };
  recipient: {
    type: string;
    accountId: string;
    accountNumber: string;
    currency: string;
  }[];
}

export const createSendMoneyConsent = (body: SendMoneyConsentData) => {
  return axios.post<Consent>('/directTransfer/consent', body).then((res) => res.data);
};

export const updateSendMoneyConsent = (consentId: string, body: SendMoneyConsentData) => {
  return axios.put<Consent>(`/directTransfer/consent/${consentId}`, body).then((res) => res.data);
};

export const makeTransfer = (consentId: string) => {
  return axios.post<Transaction>(`/directTransfer`, { consentId }).then((res) => res.data);
};

export const checkBeneficiaryByPhone = (phoneNumber: string) => {
  return axios
    .post<SendMoneyBeneficiary[]>('/directTransfer/checkBeneficiary', { phoneNumber })
    .then((res) => res.data);
};

export const checkBeneficiaryByAccountNumber = (accountNumber: string) => {
  return axios
    .post<SendMoneyBeneficiary[]>('/directTransfer/checkBeneficiary', { accountNumber })
    .then((res) => res.data);
};
